export default "__VITE_ASSET__Dgg7SW8L__"